import { put, takeLatest, call, all } from "redux-saga/effects";
import lookupsApi from "api/lookups";
import { actions } from "../actions";

// Worker Sagas
function* fetchCountriesSaga() {
  try {
    const countries = yield call(lookupsApi.getCountriesApi);
    yield put(actions.setCountries(countries));
  } catch (error) {
    console.error("Error fetching countries:", error);
    yield put(actions.setCountries([]));
  }
}

function* fetchCitiesSaga(action) {
  try {
    const cities = yield call(lookupsApi.getCitiesApi, action.countryId);
    yield put(actions.setCities(cities));
  } catch (error) {
    console.error("Error fetching cities:", error);
    yield put(actions.setCities([]));
  }
}

function* fetchDomainsSaga() {
  try {
    const domains = yield call(lookupsApi.getDomainsApi);
    yield put(actions.setDomains(domains));
  } catch (error) {
    console.error("Error fetching domains:", error);
    yield put(actions.setDomains([]));
  }
}

function* fetchSubDomainsSaga(action) {
  try {
    const subDomains = yield call(lookupsApi.getSubDomains, action.domainIds);
    yield put(actions.setSubDomains(subDomains));
  } catch (error) {
    console.error("Error fetching subDomains:", error);
    yield put(actions.setSubDomains([]));
  }
}

function* fetchLanguagesSaga() {
  try {
    const languages = yield call(lookupsApi.getLanguagesAPi);
    yield put(actions.setLanguages(languages));
  } catch (error) {
    console.error("Error fetching languages:", error);
    yield put(actions.setLanguages([]));
  }
}

function* fetchNationalitiesSaga() {
  try {
    const nationalities = yield call(lookupsApi.getNationalitiesApi);
    yield put(actions.setNationalities(nationalities));
  } catch (error) {
    console.error("Error fetching nationalities:", error);
    yield put(actions.setNationalities([]));
  }
}

function* fetchServicesSaga() {
  try {
    const services = yield call(lookupsApi.getServicesApi);
    yield put(actions.setServices(services));
  } catch (error) {
    console.error("Error fetching services:", error);
    yield put(actions.setServices([]));
  }
}

function* fetchTimezonesSaga(action) {
  try {
    const timezones = yield call(lookupsApi.getTimezonesApi, action.countryId);
    yield put(actions.setTimezones(timezones));
  } catch (error) {
    console.error("Error fetching timezones:", error);
    yield put(actions.setTimezones([]));
  }
}

function* fetchCurrenciesSaga() {
  try {
    const response = yield call(lookupsApi.getCurrencies);
    yield put(actions.setCurrencies(response));
  } catch (error) {
    console.error("Error fetching currencies:", error);
    yield put(actions.setCurrencies([]));
  }
}

function* fetchPoStatusesSaga() {
  try {
    const poStatuses = yield call(lookupsApi.getPoClientStatuses);
    yield put(actions.setPoStatuses(poStatuses.data));
  } catch (error) {
    console.error("Error fetching PO statuses:", error);
    yield put(actions.setPoStatuses([]));
  }
}
function* fetchBillingEntitySaga() {
  try {
    const billingEntity = yield call(lookupsApi.getBillingEntity);

    yield put(actions.setBillingEntity(billingEntity));
  } catch (error) {
    console.error("Error fetching Billing entity:", error);
    yield put(actions.setBillingEntity([]));
  }
}

// Watcher Saga
export function* lookupsSaga() {
  yield all([
    takeLatest(actions.VM_FETCH_COUNTRIES, fetchCountriesSaga),
    takeLatest(actions.VM_FETCH_CITIES, fetchCitiesSaga),
    takeLatest(actions.VM_FETCH_DOMAINS, fetchDomainsSaga),
    takeLatest(actions.VM_FETCH_SUB_DOMAINS, fetchSubDomainsSaga),
    takeLatest(actions.VM_FETCH_LANGUAGES, fetchLanguagesSaga),
    takeLatest(actions.VM_FETCH_NATIONALITIES, fetchNationalitiesSaga),
    takeLatest(actions.VM_FETCH_SERVICES, fetchServicesSaga),
    takeLatest(actions.VM_FETCH_TIMEZONES, fetchTimezonesSaga),
    takeLatest(actions.VM_FETCH_CURRENCIES, fetchCurrenciesSaga),
    takeLatest(actions.VM_FETCH_PO_STATUSES, fetchPoStatusesSaga),
    takeLatest(actions.VM_FETCH_BILLING_ENTITY, fetchBillingEntitySaga),
  ]);
}
